import { render, staticRenderFns } from "./ItemDialogComponent.vue?vue&type=template&id=7770111a&scoped=true"
import script from "./ItemDialogComponent.vue?vue&type=script&lang=js"
export * from "./ItemDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./ItemDialogComponent.vue?vue&type=style&index=0&id=7770111a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7770111a",
  null
  
)

export default component.exports